class ct_product_card extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".ct-product-card-images-shoppingBag").forEach((bag) => {
      bag.addEventListener("click", () => {this.openVariants(bag)});
    });
    this.querySelectorAll(".ct-product-card-variantBox-closer").forEach((closer) => {
      closer.addEventListener("click", () => {this.closeVariants()});
    });
    this.querySelectorAll(".ct-product-card-variantBox-items span[variant-id]").forEach((variant) => {
      variant.addEventListener("click", () => { this.chooseVariant(variant) });
    });
    this.querySelectorAll(".ct-product-card-variantBox-atc").forEach((atc) => {
      atc.addEventListener("click", () => {
        this.addProductToCart();
      });
    });
    this.querySelectorAll(".ct-product-card-images-wishlist").forEach((bm) => {
      bm.addEventListener("click", () => {
        this.toggleWishlist(bm);
      });
    });
  }
  connectedCallback() {
    this.applyWishlist();
  }
  openVariants() {
    this.querySelector(".ct-product-card-variantBox").setAttribute("opened", "");
  }
  closeVariants() {
    this.querySelector(".ct-product-card-variantBox").removeAttribute("opened");
  }
  addProductToCart() {
    const variant = this.querySelector(".ct-product-card-variantBox-items").querySelector("[active]");
    let products = {
      'items': [{
        'id': variant.getAttribute("variant-id"),
        'quantity': 1
      }]
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(products)
    })
    .then(response => {
      if(response.ok) {
        const cartDrawer = document.querySelector("ct-cart-drawer");
        cartDrawer.heavyDrawerUpdate();
        return response.json();
      } else {
        return response.json().then(errorData => {
          const errorWrapper = document.querySelector("ct-error-wrapper");
          errorWrapper.launchError(errorData.message);
        });
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });    
  }
  chooseVariant(element) {
    if(!element.hasAttribute("disabled")) {
      const parent = element.parentElement;
      Array.from(parent.children).forEach((child) => {
        child.removeAttribute("active");
        element.setAttribute("active", "");
      });
    }
  }
  toggleWishlist(element) {
    if(element.hasAttribute("wl-first")) {
      element.classList.add("ct-hidden");
      element.nextElementSibling.classList.remove("ct-hidden");
      let wishlistArray = [];
      if(localStorage.getItem("wishlist")) {
        wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      }
      const prodID = this.getAttribute("data-id");
      const prodHandle = this.querySelector("a[href]").getAttribute("href").replace("/products/", "");
      let newItem = {
        id: prodID,
        handle: prodHandle
      }
      wishlistArray.push(newItem);
      localStorage.setItem("wishlist", JSON.stringify(wishlistArray));
    } else if(element.hasAttribute("wl-second")) {
      element.classList.add("ct-hidden");
      element.previousElementSibling.classList.remove("ct-hidden");
      let wishlistArray = [];
      if(localStorage.getItem("wishlist")) {
        wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      }
      const prodID = this.getAttribute("data-id");
      wishlistArray = wishlistArray.filter(item => item.id !== prodID);
      localStorage.setItem("wishlist", JSON.stringify(wishlistArray));
      if(wishlistArray.length == 0) {
        localStorage.removeItem("wishlist");
      }
    }
    const header = document.querySelector("ct-header");
    header.buildWishList();
  }
  applyWishlist() {
    const prodID = this.getAttribute("data-id");
    if(localStorage.getItem("wishlist")) {
      const wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      let itemToFind = wishlistArray.find(item => item.id === prodID);
      if(itemToFind) {
        const element = this.querySelector(".ct-product-card-images-wishlist[wl-first]");
        element.classList.add("ct-hidden");
        element.nextElementSibling.classList.remove("ct-hidden");
      }
    }
  }
}

customElements.define("ct-product-card", ct_product_card);